import type { Collection, Custodian } from './collection';

export interface ProjectRole {
  id: string;
  name: string;
  projectId: string;
  permissions: string[];
  canEdit: boolean;
  tagRestriction?: {
    and: unknown[]; or: unknown[]; not: unknown[];
    andIds: string[]; orIds: string[]; notIds: string[];
    empty: boolean;
  };
}

export type ProjectStatus = 'active' | 'trial' | 'hibernate' | 'purged';

export interface Project {
  id: string;
  name: string;
  description?: string | null;
  companyFirmName?: string;
  createdAt: number;
  numCollections: number;
  status: ProjectStatus;
  favorite: boolean;
  type: string;
  organizationId?: string | null;
  roles: ProjectRole[];
  hibernateDate?: number;
}

export function hasPermission(project: Project, permission: string): boolean {
  return project.roles?.some(r => r.permissions?.includes(permission)) ?? false;
}

export function isAdmin(project: Project): boolean {
  return hasPermission(project, 'ADMIN_PROJECT');
}

/** Full project response returned by GET /project/:id — includes embedded collections and custodians. */
export interface ProjectDetail extends Project {
  collections: Collection[];
  custodians: Custodian[];
  timezoneId?: string;
  reactivationDate?: number;
  usageType?: string;
  redactionBoxWhite?: boolean;
  amazonTranscribeServiceEnabled?: boolean;
  googleTranslateEnabled?: boolean;
  enhancedPiiDetection?: boolean;
  dataEnrichmentEnabled?: boolean;
  hasBatches?: boolean;
  matterId?: string | null;
  projectSourceSize?: number | null;
  projectOutputSize?: number | null;
  currentBillingStart?: number;
  currentBillingEnd?: number;
  card?: {
    maskedNumber?: string;
    expires?: string;
    type?: string;
    last4?: string;
    expMonth?: number;
    expYear?: number;
  };
}
